import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { Switch } from '@mui/joy';

import GraphFillIcon from '@/Pages/Graph/icons/GraphFillIcon.svg?react';
import { DatasetPickerV2 } from '@/components/DatasetPickerV2';

import { TraceLogAvatar } from '../common/TraceLogAvatar';
import { GraphNodeTableItem } from './GraphDatasetProvider.types';

interface NodeDatasetTableProps {
  graphNodeTableItems: GraphNodeTableItem[];
  handleDatasetChange: (graphNodeItem: GraphNodeTableItem) => void;
  setGraphTabIndex: (index: number) => void;
}

export function GraphDatasetNodeTable(props: NodeDatasetTableProps) {
  return (
    <div className="flex flex-col">
      <div className="grid grid-cols-[2fr,1fr,2fr] gap-4 border-b border-secondary bg-secondary px-4 py-3">
        <div className="text-left text-sm font-medium text-tertiary">Node</div>
        <div className="-ml-6 text-sm font-medium text-tertiary">
          Enable Adding
        </div>
        <div className="text-left text-sm font-medium text-tertiary">
          Default Dataset
        </div>
      </div>
      <div className="flex flex-col divide-y divide-secondary">
        {props.graphNodeTableItems.map((item) => (
          <div
            key={item.nodeId}
            className="grid grid-cols-[2fr,1fr,2fr] items-center gap-4 px-4 py-3"
          >
            <div className="flex items-center gap-2">
              <TraceLogAvatar
                nodeName={item.nodeLabel}
                isSubgraph={item.subgraphIndex != null}
              />
              <span className="text-sm font-medium">{item.nodeLabel}</span>
              {item.subgraphIndex !== undefined && (
                <button
                  onClick={(e) => {
                    e.preventDefault();
                    if (item.subgraphIndex === undefined) return;
                    props.setGraphTabIndex(item.subgraphIndex);
                  }}
                  type="button"
                  className="flex items-center gap-[2px] rounded-lg border-[1px] border-primary px-[3px] py-[2px] text-xs"
                >
                  <GraphFillIcon className="h-3 w-3" />
                  <span>subgraph</span>
                  <ArrowRightIcon className="h-4 w-4" />
                </button>
              )}
            </div>
            <div>
              <Switch
                checked={item.enabled}
                onChange={(event) => {
                  props.handleDatasetChange({
                    ...item,
                    enabled: event.target.checked,
                  });
                }}
              />
            </div>
            <div className="overflow-hidden">
              <DatasetPickerV2
                className="w-full"
                value={item.datasetNameOrId}
                onChange={(datasetNameOrId) => {
                  if (!datasetNameOrId) return;
                  props.handleDatasetChange({
                    ...item,
                    datasetNameOrId,
                  });
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
